// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"570":"e165401d","822":"bc978049"}[chunkId] + ".chunk.css";
};